var React = require('react');

function IcExit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 8H13V4H5V20H13V16H15V22H3V2H15V8ZM23.4141 12L18.707 16.707L17.293 15.293L19.5859 13H9V11H19.5859L17.293 8.70703L18.707 7.29297L23.4141 12Z","fill":"black"}));
}

IcExit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcExit;

IcExit.default = IcExit;
